import * as React from "react";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { CardsCarouselModuleModel } from "./models/CardsCarouselModule.model";
import Slider from "react-slick";
import CardModule from "../CardModule";
import { useState, useRef, useEffect } from "react";
import { GenerateIdForGA } from "../../types/helpers";
import "./index.scss";
import CardModuleLinkedItem from "../CardModuleLinkedItem";
import { bindPropsToComponentFields } from "../../utils/dochubUtils";

const CardsCarouselModule = (props) => {
  if (props?.paramsFields) {
    props?.fields?.List.map((item) => {
      bindPropsToComponentFields(item, props?.paramsFields);
    });
  }

  const model = new CardsCarouselModuleModel(props);
  const cardCarouselContent = React.useRef(null);

  const isRtl = props?.sitecoreContext?.ContextExtensions?.isRTL;
  const cards = model?.List;
  const marginTop = props?.params?.TopMargin ? `margin-top__${props?.params?.TopMargin}` : "";
 const marginBottom = props?.params?.BottomMargin ? `margin-bottom__${props?.params?.BottomMargin}` : "";

  const [isLandscape, setIsLandscape] = useState(typeof window !== "undefined" ? window.orientation != 0 : false);

  const cardsCarouselRef = useRef(null);
  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return <div className={className} style={{ ...style }} onClick={onClick}></div>;
  };
  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return <div className={className} style={{ ...style }} onClick={onClick}></div>;
  };
  if (typeof window !== "undefined") {
    window.addEventListener("orientationchange", () => setScreenOrientation());
  }
  const setScreenOrientation = () => {
    if (typeof window !== "undefined") {
      let isIs = window.orientation != 0;
      if (isLandscape != isIs) {
        setIsLandscape(window.orientation != 0);
      }
    }
  };

  const settings = {
    arrows: true,
    dots: false,
    rtl: isRtl,
    slidesToScroll: 1,
    slidesToShow: 3.3,
    infinite: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    touchMove: false,
    responsive: [
      {
        breakpoint: 1367,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: false,
          dots: isLandscape ? true : false,
          touchMove: isLandscape ? true : false,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          touchMove: true,
        },
      },
      {
        breakpoint: 959,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          touchMove: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          touchMove: true,
        },
      },
    ],
  };
  const afterChange = () => {
    setTimeout(() => {
      let array = [];
      const getSlickList = cardCarouselContent?.current?.querySelectorAll(".slick-dots li"),
        getLatestSlickListElement = cardCarouselContent?.current?.querySelector(".slick-dots li:last-of-type");

      getSlickList?.forEach((element: any) => {
        array.push(element.classList.contains("slick-active"));
      });
      if (array.every((v) => v === false)) {
        getLatestSlickListElement?.classList.add("slick-active");
      } else {
        getLatestSlickListElement?.classList.remove("slick-active");
      }
    }, 0);
  };

  const sliderRef = useRef(null);

  const [innerInternalWidth, setInnerInternalWidth] = useState(0);

  useEffect(() => {
    if (typeof window != "undefined") {
      setInnerInternalWidth(window.innerWidth);
      window.addEventListener("resize", () => {
        setInnerInternalWidth(window.innerWidth);
      });
    }
    if (isRtl) {
      const timeout = setTimeout(() => {
        const slickDots = document.querySelector(".slick-dots");
        const dotsLength = slickDots ? slickDots.children.length : 0;
        if (innerInternalWidth < 575) {
          if (sliderRef.current) {
            sliderRef.current.slickGoTo(dotsLength);
          }
        } else if (innerInternalWidth > 575 && innerInternalWidth < 1023) {
          if (sliderRef.current) {
            if (cards.length > 3) {
              sliderRef.current.slickGoTo(cards.length - 2);
            } else {
              sliderRef.current.slickGoTo(cards.length - 1);
            }
          }
        } else {
          if (sliderRef.current) {
            if (cards.length > 3) {
              sliderRef.current.slickGoTo(cards.length - 3);
            } else {
              sliderRef.current.slickGoTo(cards.length - 2);
            }
          }
        }
      }, 50);

      return () => clearTimeout(timeout);
    }
  }, [innerInternalWidth]);

  return (
    <>
      <section
        className={`container card-carousel-section section-space 1 ${"theme-" + model?.theme} ${props?.fields?.Opacity?.value} ${
          isRtl ? "card-carousel-rtl" : ""
        } ${marginTop} ${marginBottom}`}
        id={props?.rendering?.dataSource}
        ref={cardsCarouselRef}
      >
        <div className={`card-carousel-content`} ref={cardCarouselContent}>
          <Slider {...settings} beforeChange={afterChange} ref={sliderRef}>
            {cards?.map((cardGrid, i) => {
              return (
                <>
                  {cardGrid?.fields?.["Use Linked Item"]?.value == true ? (
                    <CardModuleLinkedItem
                      id={GenerateIdForGA("cardsCarousel", "card")}
                      key={i}
                      dataFromParent={cardGrid?.fields?.["Linked Item"]}
                      index={i}
                      dataModal={props?.fields?.Open?.value}
                      dataRendering={props?.rendering}
                    ></CardModuleLinkedItem>
                  ) : (
                    <CardModule
                      id={GenerateIdForGA("cardsCarousel", "card")}
                      key={i}
                      dataFromParent={cardGrid}
                      index={i}
                      dataModal={props?.fields?.Open?.value}
                      dataRendering={props?.rendering}
                    ></CardModule>
                  )}
                </>
              );
            })}
          </Slider>
        </div>
      </section>
    </>
  );
};

export default withSitecoreContext()(CardsCarouselModule);
